import React from 'react';
import { oneOfType, string, number } from 'prop-types';
import { useStore } from '@thd-nucleus/experience-context';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { StateDirectoryService } from './StateDirectoryService';

export const StateDirectoryContainer = ({ timeout, ...props }) => {
  const store = useStore();
  const { storeId, storeZip } = store;

  return (
    <QueryProvider cacheKey="state-directory">
      <StateDirectoryService />
    </QueryProvider>
  );
};

StateDirectoryContainer.propTypes = {
  timeout: oneOfType([string, number])
};

StateDirectoryContainer.defaultProps = {
  timeout: '3000'
};
